export const getUseTypeMultipleSelectFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
